import axios from '../axios'
import qs from "qs";

function service(endpoint) {

    function openers(id, data = {}) {
        return axios.get(`${endpoint}/${id}/openers`, { params: data, paramsSerializer: params => qs.stringify(params, { encode: false })  }).then(response => {
            return response.data;
        }).catch(e => {
            throw e;
        });
    }

    function deliveries(id, data = {}) {
        return axios.get(`${endpoint}/${id}/deliveries`, { params: data, paramsSerializer: params => qs.stringify(params, { encode: false })  }).then(response => {
            return response.data;
        }).catch(e => {
            throw e;
        });
    }

    function fails(id, data = {}) {
        return axios.get(`${endpoint}/${id}/fails`, { params: data, paramsSerializer: params => qs.stringify(params, { encode: false })  }).then(response => {
            return response.data;
        }).catch(e => {
            throw e;
        });
    }

    function blacklisted(id, data = {}) {
        return axios.get(`${endpoint}/${id}/blacklisted`, { params: data, paramsSerializer: params => qs.stringify(params, { encode: false })  }).then(response => {
            return response.data;
        }).catch(e => {
            throw e;
        });
    }

    function unsubscribed(id, data = {}) {
        return axios.get(`${endpoint}/${id}/unsubscribed`, { params: data, paramsSerializer: params => qs.stringify(params, { encode: false })  }).then(response => {
            return response.data;
        }).catch(e => {
            throw e;
        });
    }

    function waitingForSending(id, data = {}) {
        return axios.get(`${endpoint}/${id}/waiting-for-sending`, { params: data, paramsSerializer: params => qs.stringify(params, { encode: false })  }).then(response => {
            return response.data;
        }).catch(e => {
            throw e;
        });
    }

    return {
        openers,
        deliveries,
        fails,
        blacklisted,
        unsubscribed,
        waitingForSending
    }
}

export default service
